// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styles from './switchClientDropdown.scss';
import ClientSearch from '../clientSearch';
import {
  toggleSwitchClientDisplay,
  getClientsForSwitchClientOption
} from './switchClientDropdownRedux/switchClientDropdownActionCreator';
import { setClientSearchInput } from '../clientSearch/clientSearchRedux/clientSearchActionCreator';

type Props = {
  showSwitchClientOption: boolean,
  toggleSwitchClientDisplay: Function,
  getClientsForSwitchClientOption: Function
};

const onClientChange = (props, obj) => {
  props.toggleSwitchClientDisplay(false);
  props.getClientsForSwitchClientOption(obj);
};

const SwitchClientDropdown = (props: Props) =>
  props.showSwitchClientOption ? (
    <div className={`${styles.switchClientWrapper} l-col`}>
      <div className={`${styles.switchClientHeader} l-row`}>
        <div className={`${styles.headerValues}`}>&#8646;</div>
        <div className={`${styles.headerValues}`}>Switch Client</div>
      </div>
      {props.setClientSearchInput('')}
      <ClientSearch
        onSelect={(val, obj) => {
          onClientChange(props, obj);
        }}
        isServiceabilityClient={true}
        disableNone={true}
      />
    </div>
  ) : null;

SwitchClientDropdown.defaultProps = {
  showSwitchClientOption: false
};

const mapStateToProps = state => ({
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  toggleSwitchClientDisplay: bindActionCreators(
    toggleSwitchClientDisplay,
    dispatch
  ),
  getClientsForSwitchClientOption: bindActionCreators(
    getClientsForSwitchClientOption,
    dispatch
  ),
  setClientSearchInput: bindActionCreators(setClientSearchInput, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SwitchClientDropdown);
